import script from "./AlertBox.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertBox.vue?vue&type=script&setup=true&lang=js"

import "./AlertBox.vue?vue&type=style&index=0&id=3d1d57ba&lang=postcss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d1d57ba"]])

export default __exports__